<script>

var sha512 = require('js-sha512');

import LoadingScreen from '@/components/General/LoadingScreen'
import Alert from '@/components/General/Alert'


//general functions
import MixinGeneralFunct from '@/mixins/GeneralFunctions';

import { useToast } from "vue-toastification";

//data
import { getUserDataPswd, savePass } from '@/services/serviceUser';
import { logoutUser } from '@/services/serviceLogin';

export default {
	setup() {
		const toast = useToast();
		return { toast }
	},
	name: 'UserChangePass',
	mixins: [ MixinGeneralFunct ],
	components: {
		LoadingScreen
		,Alert
	},
	props: {'auth':Object, 'secData':Object, 'params':Object},
	data() {
		return {
			prefix:'',
		
			
			metaData:[],
		
			isLoading:true,
			
			result:[],
			userInputs:[]
		}
	},
	
	mounted:function(){
	
	},
	
	methods: {
		
		//default data
		onLoadPage:function(){
			
			//show loader
			this.isLoading=true
			
			getUserDataPswd().then(response => {
				console.log(response)
				if(!response.statusText){
					this.isLoading=false
					this.result = response.result;
					this.metaData = response.metaData;
					this.userInputs = response.userInputs;
					
				}else{
					this.isLoading=false
					this.errorStatus=`${response.statusText} ${response.status}`
				}
			});
		
		},
		
		checkPasswordV2:function()
		{
			//1.
			if(this.userInputs.password.length < 6){
				this.userInputs.passwordError = true;
				this.toast.error(this.$t('msgCore.passwordIsTooShort'));
				return false;
			}
			
			//2.
			var re = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}/; 
			if (!re.test(this.userInputs.password)) {
				this.userInputs.passwordError = true;	
				this.toast.error(this.$t('msgCore.passwordMustHaveSmallBigLettersAndNumbers'));
				return false;
			}
				
			
			//3.
			if (this.userInputs.password != this.userInputs.passwordRepeat){
				this.userInputs.passwordError = true;		
				this.userInputs.passwordRepeatError = true;	
				this.toast.error(this.$t('msgCore.passwordsDoNotMatch'));
				return false;
			}
			
			this.userInputs.passwordError = false;
			this.userInputs.passwordRepeatError = false;
			return true;

		},
			
		//zobrazi heslo
		showPswd: function(){
			this.userInputs.showInput = this.userInputs.showInput===true?false:true;
		},

		//odhlasenie reg ucastnika
		onLogOut:function(){
			
			logoutUser().then(response => {
				console.log(response)
				if(!response.statusText){
					
					var user = response.userData;
				
					if(!user.isReg){
						location.reload();
					}
					
				}else{
					this.isLoading=false
					this.errorStatus=`${response.statusText} ${response.status}`
				}
			});
			
		},

		onSavePswd:function(){
				
			this.cSession();
			
			if(this.checkPasswordV2()){
			
				savePass({p:sha512(this.userInputs.password),userId:''}).then(response => {

					this.userInputs.password='';

					if(!response.statusText){
						this.isLoading=false
						if(response.resCode==1){
							this.toast.success(this.$t('msgCore.dataWasSaved'));
							setTimeout(this.onLogOut, 2000);
						}else if(response.resCode==0){
							this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
						}else if(response.resCode==2){
							this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
						}else if(response.resCode==3){
							this.toast.error(this.$t('msgCore.accessDenied'));
						}
					}else{
						this.isLoading=false
						this.toast.error(`${response.statusText} ${response.status}`);
					}
				});

			}
			
		},
		
	},	
			
	watch: {
		auth(){
			this.onLoadPage();
		}
	},

	computed:{
		
	},
	
}

</script>

<template>
	<div>
		<LoadingScreen :isLoading="isLoading"></LoadingScreen>
		<div id="version" class="version"><p>{{metaData.version}}</p></div>
				
		<div v-if="metaData.modulAccess"> 
				
			<div class="row">
				<div class="col-12">
						
					<div class="row">
						<div class="col-12">
							<h5>{{ $t('msgCore.setPassword') }}</h5>
							<h6 class="modal-title"><b><span>{{ result.name }} {{ result.surname }}</span></b></h6>
						</div> 
					</div>
					
					<div class="row">
			
						<div class="col-md-3 col-12">
							<div class="input-group">
								<input :type="userInputs.showInput ? 'text' : 'password'" autocomplete="new-password" v-on:change="checkPasswordV2()" class="form-control form-control-sm" value='' v-model="userInputs.password" :placeholder="$t('msgCore.Password')" >
								<button type="button" class="btn btn-outline-info btn-sm my-btn" v-on:click="showPswd()">
									<i v-if="!userInputs.showInput" :title="$t('msgCore.showPassword')" class="smire-icon far fa-eye"></i>
									<i v-else :title="$t('msgCore.hidePassword')" class="smire-icon far fa-eye-slash"></i>
								</button>
							</div>
							<div v-show="userInputs.passwordError" class="error-input">chyba</div>
						</div>
						
						<div class="col-md-3 col-12">
							<div class="input-group">
								<input :type="userInputs.showInput ? 'text' : 'password'" autocomplete="new-password" v-on:change="checkPasswordV2()" class="form-control form-control-sm" value='' v-model="userInputs.passwordRepeat" :placeholder="$t('msgCore.passwordRepeat')" >
								<button type="button"  class="btn btn-outline-info btn-sm my-btn" v-on:click="showPswd()">
									<i v-if="!userInputs.showInput" :title="$t('msgCore.showPassword')" class="smire-icon far fa-eye"></i>
									<i v-else :title="$t('msgCore.hidePassword')" class="smire-icon far fa-eye-slash"></i>
								</button>								
							</div>
							<div v-show="userInputs.passwordRepeatError" class="error-input">chyba</div>
						</div>	
					</div>	
					
					<div class="btn-group">
						<button type="button" v-on:click="onSavePswd()" class="btn btn-warning btn-sm">{{ $t('msgCore.btnSave') }}</button>	
					</div>
					
				</div>	
			</div>
			
			
			<div class="row">
				<div class="col-12">
					<h6 class="modal-title"><b><span class="text-danger">{{ $t('msgCore.YouWillBeLoggedOutAfterSuccessChangPassword') }}</span></b></h6>
				</div>	
			</div>
							
		</div>
		
		<div v-else >
			<div class="row">
				<div class="col-12 mt-3">
					<Alert type="warning" :label="$t('msgCore.accessDenied')" />
				</div>
			</div>
		</div>
	</div>
</template>


